import Login from "../views/Login/index.js";
import Dashboard from "../views/Dashboard/index.js";
import NewDashboard from "../views/Dashboard/NewDashboard.js";
import { createBrowserRouter } from "react-router-dom";
import UserManagement from "../views/UserManagement/index.js";
// import Invite from "../views/invite/";
// import Tracking from "../views/Tracking/index.js";
import RoleManagement from "../views/RoleManagement/index.js";
import { createRef } from "react";
import Invite from "../views/invite/index.js";
import MasterManager from "../views/MasterManager/index.js";
import Visitmanagement from "../views/VisitManagement/index.js";
import AttendanceManagement from "../views/attendanceManagement/index.js";
import OrderManagement from "../views/orderManagement/index.js";
import PartyManagement from "../views/partyManagement/index.js";
import SeriesManagement from "../views/SeriesManagement/index.js";
import ProductManagement from "../views/productManagement.js/index.js";
import RoutePlanManagement from "../views/routePlanManagement/index.js";
import CollectionManagement from "../views/collectionManagement/index.js";
import SpecimenManagement from "../views/specimenManagement/index.js";
import NotificationCentral from "../views/NotificationCentral/index.js";
import LeadManagement from "../views/leadManagement/index.js";
import TransporterManagement from "../views/transporterManagement/index.js";
import AttendanceReport from "../views/report/attendanceReport.js";
import AuditLogs from "../views/AuditLogs/index.js";
import TotalTimeWorkedReport from "../views/report/totalTimeWorkedReport.js";
import WorkTimeSchoolDistributor from "../views/report/calculateTimeForSchoolAndDistributor.js";
import WorkTypePicklist from "../views/Picklist/workType.js";
import PartyTypePicklist from "../views/Picklist/partyType.js";
import BoardMaster from "../views/Picklist/boardMaster.js";
import BookType from "../views/Picklist/bookType.js";
import ClassMaster from "../views/Picklist/classMaster.js";
import CollectionType from "../views/Picklist/collectionType.js";
import ContactPersonRole from "../views/Picklist/contactPersonRole.js";
import DaType from "../views/Picklist/daType.js";
import FeedbackMaster from "../views/Picklist/feedbackMaster.js";
import GivenType from "../views/Picklist/givenType.js";
import GradeMaster from "../views/Picklist/gradeMaster.js";
import MediumMaster from "../views/Picklist/mediumMaster.js";
import NextType from "../views/Picklist/nextStep.js";
import PaymentType from "../views/Picklist/paymentType.js";
import RecieveCollection from "../views/Picklist/recieveCollection.js";
import RouteVisitType from "../views/Picklist/routeVisitType.js";
import StatusType from "../views/Picklist/statusType.js";
import SubjectMaster from "../views/Picklist/subjectMaster.js";
import VehicleType from "../views/Picklist/vehicleType.js";
import VisitType from "../views/Picklist/visitType.js";
import WorkDone from "../views/Picklist/workDone.js";
import PartyUpdateApproval from "../views/partyUpdateApproval/index.js";
import TrackingManagement from "../views/trackingManagement/index.js";
import ConsentDetails from "../views/consentDetails/ConsentDetails.js";
import ExpenseManagement from "../views/expenseManagement/index.js";
import Incentives from "../views/Incentives/incentives.js";
import SpecimenAllotment from "../views/specimenAllotmentManagement/index.js";
import ReturnOrder from "../views/orderManagement/returnOrder.js";
import OrderReport from "../views/report/orderReport.js";
import VisitDetailReport from "../views/report/visitDetailReport.js";
import VisitSummarizedReport from "../views/report/visitSummarisedReport.js";
import ForecastReport from "../views/forecastReport/index.js";
import ReturnReasonReport from "../views/returnReasonReport/index.js";
import ReturnOrderLineItemReport from "../views/returnReasonReport/fetchReturnOrderLineItem.js";
import FinancialReport from "../views/financialReport/index.js";
import PipelineReport from "../views/pipelineReport/index.js";
import AllPicklist from "../views/allPicklist/index.js";
import ExpensePurpose from "../views/Picklist/expensePurpose.js";
import Author from "../views/Picklist/Author.js";
import Language from "../views/Picklist/Language.js";
import DocumentListSchool from "../views/Picklist/documentListSchool.js";
import ExpenseType from "../views/Picklist/expenseType.js";
import DeliveryStatus from "../views/Picklist/deliveryStatus.js";
import LeadStatus from "../views/Picklist/leadStatus.js";
import LeadSource from "../views/Picklist/leadSource.js";
import LeadRating from "../views/Picklist/leadRating.js";
import SchoolCategory from "../views/Picklist/schoolCategory.js";
import VisitOutcome from "../views/Picklist/visitOutcome.js";
import ReturnReason from "../views/Picklist/returnReason.js";
import ProductGroup from "../views/Picklist/productGroup.js";
import MittplusProductGroup from "../views/Picklist/mittplusProductGroup.js";
import SeriesMaster from "../views/Picklist/seriesMaster.js";
import AddOnProducts from '../views/Picklist/AddOnProducts.js'
import RemarkComponent from "../views/Picklist/RemarkComponent.js";
import WareHouseComponent from "../views/Picklist/WareHouseComponent.js";
import VisitTypeCheck from "../views/Picklist/VisitTypeCheck.js";
import StockistManagement from "../views/Stockist/StockistManagement.js";
import IncentiveManagement from "../views/Incentives/IncentiveManagement.js";
import ClusterComponent from "../views/Picklist/ClusterComponent.js";
import NotificationEmail from "../views/Picklist/NotificationEmail.js";
import LocationManagement from "../views/LocationManagement/index.js";
import CustomerType from "../views/Picklist/CustomerType.js";
import InputSource from "../views/Picklist/InputSource.js";
import SchoolType from "../views/Picklist/SchoolType.js";
import Reason from "../views/Picklist/Reason.js";
import AttendanceConfig from "../views/Picklist/AttendanceConfig.js";
import Cities from "../views/Picklist/Cities.js";
import ExpenseSubType from "../views/Picklist/ExpenseSubType.js";
import LiveAudit from "../views/liveAudit/LiveAudit.js";
import Allowances from "../views/Allowances/Allowances.js";
import SchoolPage from "../views/School/SchoolPage.js";
import DistributorPage from "../views/Distribution/DistributionPage.js";
import MergeParty from "../views/MergeParty/index.js";
import FAQ from "../views/FAQ/index.js";
import PincodeConfig from "../views/Picklist/PincodeConfig.js";
import SessionManagement from "../views/Picklist/SessionManagement.js";
import ReportCentral from "../views/ReportCentral/index.js";
import AccessManagement from "../views/AccessManagement/index.js";
import AllotedSpecimen from "../views/specimenManagement/AllotedSpecimen.js";
import AutomationLogs from "../views/AutomationLogs/AutomationLogs.js";
import OlympiadRegistration from "../views/OlympiadRegistration/OlympiadRegistration.js";
import OlympiadClubbing from "../views/OlympiadRegistration/OlympiadClubbing.js";




// const router = createBrowserRouter([
//     {
//       path: "/",
//       element: 
//           <Dashboard/>
    
    
//     },
//     {
//         path: "/login",
//         element: <Login />,
//         redirect: AuthContext,
//         pathTo: "/",
//     }
//     ,{
//         path: "/usermanagement",
//         element: <PrivateRoute><UserManagement/></PrivateRoute>
//     }

//   ]);

// export default router;

function routes(loggedIn, user){
    return[
        {
            path: "/login",
            name: "Login",
            component: Login,
            redirect: user,
            pathTo: "/dashboard",
            hideNavBar:true,
            // nodeRef: createRef(),
        },
      
        {
            redirect: loggedIn === false,
            path: "*",
            pathTo: "/login",
        },

        {
            path: "/dashboard",
            name: "Dashboard",
            component: Dashboard,
             hideNavBar:true,
            //  nodeRef: createRef(),
        },
         {
            path: "/dashboard1",
            name: "Dashboard 1",
            component: NewDashboard,
             hideNavBar:true,
            //  nodeRef: createRef(),
        },
        {
            redirect: loggedIn,
            path: "*",
            pathTo: "/dashboard",
         },
         {
            path: "/usermanagement",
            name: "User Management",
            component: UserManagement,
            nodeRef: createRef(),
            access : 'User Management'
        },
        // {
        //     path: "/tracking",
        //     name: "Tracking",
        //     component: Tracking,
        //     nodeRef: createRef(),

            
        // },
        {
            path: "/rolemanagement",
            name: "Role Management",
            component: RoleManagement,
            access: 'Role Management'

        },
        {
            path: "/mastermanager",
            name: "MasterManager",
            component: MasterManager,
            access: 'Master Manager'

        },
        {
            path: "/expenseManagement",
            name: "Expense Management",
            component: ExpenseManagement,
            access: 'Expense Management'

        },
      
        {
            path:"/platformInvite",
            name:"Invite",
            component:Invite,
            hideNavBar:true
        },
        {
            path:"/visitmanagement",
            name:"Visit Management",
            component:Visitmanagement,
            access: 'Visit Management'
            // hideNavBar:true
        },
        {
            path:"/attendancemanagement",
            name:"Attendance Management",
            component:AttendanceManagement,
            access: 'Attendance Management'

            // hideNavBar:true
        },
        {
            path:"/stockistmanagement",
            name:"Stockist Management",
            component:StockistManagement,
            access: 'Stockist Management'
        },
        {
            path:"/incentivemanagement",
            name:"Incentive Management",
            component:IncentiveManagement,
            access: 'Incentive Management'
        },
        {
            path:"/bookingConfirmation",
            name:"Booking Confirmation",
            component:(props)=><OrderManagement {...props} propType={"Sales"} />,
            // hideNavBar:true
            access: 'Booking Confirmation'
        },
        // {
        //     path:"/ordermanagement",
        //     name:"Order Management",
        //     component:OrderManagement,
        //     access: 'Order Management'

        //     // hideNavBar:true
        // },

        {
            path:"/ordermanagement",
            name:"Order Management",
            component:(props)=><OrderManagement {...props} propType={"saleS"} />,
            // hideNavBar:true
            access: 'Order Management'
        },
        {
            path:"/specimenManagement",
            name:"Specimen Management",
            component:(props)=><OrderManagement {...props} propType={"Specimen"} />,
            // hideNavBar:true
            access: 'Specimen Management'
        },
        {
            path:"/partymanagement",
            name:"Party Management",
            component:PartyManagement,
            access: 'Party Management'

            // hideNavBar:true
        },
        {
            path:"/mergeparty",
            name:"Merge Party",
            component:MergeParty,
            access: 'Merge Party'

            // hideNavBar:true
        },
        {
            path:"/NotificationCentral",
            name:"Notification Central",
            component:NotificationCentral,
            // hideNavBar:true
            access: 'Notification Central'
        },
         {
            path:"/FAQ",
            name:"FAQ",
            component:FAQ,
            access: 'FAQ'

            // hideNavBar:true
        },
        {
            path:"/automationLogs",
            name:"Automation Logs",
            component:AutomationLogs,
            // hideNavBar:true
            access: 'Automation Logs'
        },
        {
            path:"/olympiadRegistration",
            name:"Olympiad Registration",
            component:OlympiadRegistration,
            // hideNavBar:true
            access: 'Olympiad Registration'
        },
        {
            path:"/olympiadClubbing",
            name:"Olympiad Clubbing",
            component:OlympiadClubbing,
            // hideNavBar:true
            access: 'Olympiad Clubbing'
        },
        {
            path:"/productManagement",
            name:"Product Management",
            component:ProductManagement,
            access: 'Product Management'

            // hideNavBar:true
        },
        {
            path:"/setManagement",
            name:"Set",
            component:SeriesManagement,
            access: 'Set Management'

            // hideNavBar:true
        },
        {
            path:"/routeplanManagement",
            name:"Route Plan Management ",
            component:RoutePlanManagement,
            // hideNavBar:true
            access: 'Route Plan Management'

        },
          {
            path:"/allowances",
            name:"Allowances",
            component:Allowances,
            // hideNavBar:true
            access: 'allowances'

        },
          {
            path:"/lastLocation",
            name:"Last Location",
            component:LiveAudit,
            // hideNavBar:true
            access: 'Last Location'

        },
        //  {
        //     path:"/lastLocation",
        //     name:"Last Location",
        //     component:LastLocation,
        //     // hideNavBar:true
        //     access: 'Last Location'

        // },
        {
            // path:"/collectionManagement",
            // name:"Collection",
            // component:CollectionManagement,
            // // hideNavBar:true
            // access: 'Collection Management'

        },
        {
            path:"/incentives",
            name:"Incentives",
            component:Incentives,
            access: 'Incentives'

            // hideNavBar:true
        },
        {
            path:"/leadManagement",
            name:"Lead Management",
            component:LeadManagement,
            // hideNavBar:true
            access: 'Lead Management'

        },
        {
            path: "/transporterManagement",
            name: "Transporter Management",
            component: TransporterManagement,
            access: 'Transporter Management'
        },
        {
            path: "/forecastReport",
            name: "Forecast Report",
            component: ForecastReport,
            access: 'Forecast Report'
        },
        {
            path: "/financialReport",
            name: "Financial Report",
            component: FinancialReport,
            access: 'Financial Report'
        },
        {
            path: "/pipelineReport",
            name: "Pipeline Report",
            component: PipelineReport,
            access: 'Pipeline Report'
        },
        {
            // path: "/returnReasonReport",
            // name: "Return Reason Report",
            // component: ReturnReasonReport,
            // access: "Return Reason Report"
        },
        {
            path: "/returnOrderLineItemReport",
            name: "Return Order Line Item Report",
            component: ReturnOrderLineItemReport,
            access: "Return Order Line Item Report"
        },
        {
            path:"/auditlogs",
            name:"Audit Logs",
            component:AuditLogs,
            // hideNavBar:true
            access: 'Audit Logs'

        },
        {
            path:"/attendanceReport",
            name:"Attendance Report",
            component:AttendanceReport,
            access: 'Attendance Report'

            // hideNavBar:true
        },
        {
            path:"/totalTimeWorkedReport",
            name:"Work Time Report",
            component:TotalTimeWorkedReport,
            access: 'Work Time Report'

            // hideNavBar:true
        },
        {
            path:"/workTimeSchoolDistributor",
            name:"Work Time Report ",
            component:WorkTimeSchoolDistributor,
            access: 'Attendance Report'

            // hideNavBar:true
        },
        {
            path:"/additionalData/workTypePicklist",
            name:"Work Type Picklist",
            component:WorkTypePicklist,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/product/seriesCategory",
            name:"Series",
            component:SeriesMaster,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/product/addOnProducts",
            name:"Add-On Products",
            component:AddOnProducts,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/product/remark",
            name:"Order Remark",
            component:RemarkComponent,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/product/wareHouse",
            name:"Ware House",
            component:WareHouseComponent,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/product/cluster",
            name:"Area",
            component:ClusterComponent,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/product/notificationEmail",
            name:"Notification Email",
            component:NotificationEmail,
            access: 'Picklist'

            // hideNavBar:true
        },
          {
            path:"/reportcentral",
            name:"Report Central",
            component:ReportCentral,
            // hideNavBar:true
            access: 'Report Central'
        },
           {
            path:"/accessManagement",
            name:"Access Management",
            component:AccessManagement,
            // hideNavBar:true
            access: 'Access Management'
        },
         {
            path:"/session/sessionManagement",
            name:"Session Management",
            component:SessionManagement,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/customerType",
            name:"Customer Type",
            component:CustomerType,
            access: 'Picklist'

            // hideNavBar:true
        },
         {
            path:"/additionalData/reason",
            name:"No Interest Reason",
            component:Reason,
            access: 'Picklist'

            // hideNavBar:true
        },
        
         {
            path:"/additionalData/cities",
            name:"Cities",
            component:Cities,
            access: 'Picklist'

            // hideNavBar:true
        },
        
         {
            path:"/additionalData/attendanceConfig",
            name:"Attendance Configuration",
            component:AttendanceConfig,
            access: 'Picklist'

            // hideNavBar:true
        },
         {
            path:"/additionalData/pincode",
            name:"Pincode Configuration",
            component:PincodeConfig,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/inputSource",
            name:"Lead Source",
            component:InputSource,
            access: 'Picklist'

            // hideNavBar:true
        },
        
        
        {
            path:"/additionalData/schoolType",
            name:"School Type",
            component:SchoolType,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/partyType",
            name:"Party Type",
            component:PartyTypePicklist,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/boardMaster",
            name:"School Board",
            component:BoardMaster,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/bookType",
            name:"Book Type Picklist",
            component:BookType,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/classMaster",
            name:"Class",
            component:ClassMaster,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/collectionType",
            name:"Collection Type",
            component:CollectionType,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/contactPersonRoleType",
            name:"Contact Person Role Type",
            component:ContactPersonRole,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/datType",
            name:"DA Type",
            component:DaType,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/feedbackMaster",
            name:"Feedback",
            component:FeedbackMaster,
            access: 'Picklist'

            // hideNavBar:true
        },
       
        {
            path:"/additionalData/givenType",
            name:"Given Type",
            component:GivenType,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/gradeMaster",
            name:"Grade",
            component:GradeMaster,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/mediumMaster",
            name:"Medium",
            component:MediumMaster,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/nextStep",
            name:"Next Step",
            component:NextType,
            access: 'Picklist'

            // hideNavBar:true
        },
       
        {
            path:"/additionalData/paymentType",
            name:"Payment Type",
            component:PaymentType,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/recieveCollectionType",
            name:"Recieve Collection Type",
            component:RecieveCollection,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/routeVisitType",
            name:"Route Visit Type",
            component:RouteVisitType,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/statusType",
            name:"Status Type",
            component:StatusType,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/subjectMaster",
            name:"Subject",
            component:SubjectMaster,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/vehicleType",
            name:"Vehicle Type",
            component:VehicleType,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/visitType",
            name:"Visit Type",
            component:VisitType,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path: "/additionalData/visitTypeCheck",
            name: "Visit Type Check",
            component: VisitTypeCheck,
            access: 'Picklist'
        },
        {
            path:"/additionalData/workDone",
            name:"Work Done",
            component:WorkDone,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/expensePurpose",
            name:"Expense Purpose",
            component:ExpensePurpose,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/author",
            name:"Author",
            component:Author,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/language",
            name:"language",
            component:Language,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/documentListSchool",
            name:"documentListSchool",
            component:DocumentListSchool,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/expenseType",
            name:"Expense Type",
            component:ExpenseType,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/expenseSubType",
            name:"Expense Sub Type",
            component:ExpenseSubType,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/deliveryStatus",
            name:"Delivery Status",
            component:DeliveryStatus,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/leadStatus",
            name:"leadStatus",
            component:LeadStatus,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/leadSource",
            name:"leadSource",
            component:LeadSource,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/leadRating",
            name:"leadRating",
            component:LeadRating,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/schoolCategory",
            name:"School Category",
            component:SchoolCategory,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/visitOutcomes",
            name:"Visit Outcomes",
            component:VisitOutcome,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/returnReason",
            name:"Return Reason",
            component:ReturnReason,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/productGroups",
            name:"Product Groups",
            component:ProductGroup,
            access: 'Picklist'

            // hideNavBar:true
        },
        {
            path:"/additionalData/mittplusProductGroups",
            name:"Mittplus Product Groups",
            component:MittplusProductGroup,
            access: 'Picklist'

            // hideNavBar:true
        },

        {
            path:"/partyUpdateApproval",
            name:"Party Update Approval",
            component:PartyUpdateApproval,
            access: 'Attendance Report'

            // hideNavBar:true
        },
        {
            path:"/orderTracking",
            name:"Order Tracking",
            component:TrackingManagement,
            access: 'Attendance Report'

            // hideNavBar:true
        },
        
        {
            path:"/specimenAllotment",
            name:"Specimen Allotment",
            component:SpecimenManagement,
            access: 'Specimen Allotment'

            // hideNavBar:true
        },
        {
            path:"/returnOrder",
            name:"Return Order",
            component:ReturnOrder,
            access: 'Return Order'

            // hideNavBar:true
        },

        {
            path:"/orderReport",
            name:"Order Report",
            component:OrderReport,
            access: 'Order Report'

            // hideNavBar:true
        },
        {
            path:"/visitDetailReport",
            name:"Visit Detail Report",
            component:VisitDetailReport,
            access: 'Visit Detail Report'

            // hideNavBar:true
        },
        {
            path:"/visitSummarisedReport",
            name:"Visit Summarised Report",
            component:VisitSummarizedReport,
            access: 'Visit Summarised Report'

            // hideNavBar:true
        },

        
        {
            path:"/locationManagement",
            name:"User Requests",
            component:LocationManagement,
            // hideNavBar:true
            access: 'User Requests'

        },


        {
            path: "/picklist",
            name: "Configuration",
            component: AllPicklist,
            access: "Configuration",
        },

        {
  path: "/school",
  name: "School",
  component: SchoolPage,
  access: "School Management"
},

   {
    path:"/distribution",
    name:"Distribution",
    component:DistributorPage,
    access:"Party Managment"
   },
   
   {
    path:"/allotedSpecimen",
    name:"Uploaded Specimen",
    component:AllotedSpecimen,
    access:"Specimen Allotment"
   }
     

    ]
}

export default routes;


// import React, { useState } from "react";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Login from "../views/Login/index.js";
// import Dashboard from "../views/Dashboard/index.js";
// import UserManagement from "../views/UserManagement/index.js";
// import PrivateRoute from "../components/PrivateRoutes/index.js";

// const RouterComponent = () => {
// //   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   return (
//     <Router>
//       <Routes>
//         <Route path="/login" element={<Login />} />
//         <Route
//           path="/"
//           element={
//             <PrivateRoute>
//               <Dashboard /> 
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/usermanagement"
//           element={<PrivateRoute><UserManagement/></PrivateRoute>}
//         />
//       </Routes>
//     </Router>
//   );
// };

// export default RouterComponent;




// import Login from "../views/Login/index.js";
// import Dashboard from "../views/Dashboard/index.js";
// import { createBrowserRouter, useRoutes } from "react-router-dom";
// import UserManagement from "../views/UserManagement/index.js";
// import PrivateRoute from "../components/PrivateRoutes/index.js";
// // import Invite from "../views/invite/";


// // export default function Router() {
// //     const routes = useRoutes([
// //     {
// //       path: "/",
// //       element: <PrivateRoute>
// //           <Dashboard/>
// //         </PrivateRoute>
// //     },
// //     {
// //         path: "/login",
// //         element: <Login />,
// //         // redirect: user,
// //         pathTo: "/dashboard",
// //     }
// //     ,{
// //         path: "/usermanagement",
// //         element: <PrivateRoute><UserManagement/></PrivateRoute>
// //     }
//     // {
//     //   path: "/Login",
//     //   elem
//     // }
// // ]);

// // return routes;
// // }

// // import { Navigate, useRoutes } from 'react-router-dom';
// // // layouts
// // import DashboardLayout from './layouts/dashboard';
// // import SimpleLayout from './layouts/simple';
// // //
// // import BlogPage from './pages/BlogPage';
// // import ModuleManagement from './pages/DistributorOnboarding.js';
// // import LoginPage from './pages/LoginPage';
// // import Page404 from './pages/Page404';
// // import ProductsPage from './pages/ProductsPage';
// // import DashboardAppPage from './pages/DashboardAppPage';
// // import PrivateRoute from './components/private-routing/PrivateRoute';
// // import DepartmentRole from './pages/DepartmentRolePage';
// // import EmployeeOnboard from './pages/EmpoyeeOnboard';
// // import RetailorOnboard from './pages/RetailerOnboarding.';
// // import DistributorOnboard from './pages/DistributorOnboarding.js';

// // ----------------------------------------------------------------------

// export default function Router() {
//   const routes = useRoutes([
//     {
//       path: '/',
//       element: <Login />,
//     },
//     // {
//     //   path: '/dashboard',
//     //   element:<PrivateRoute> <DashboardLayout /> </PrivateRoute>,
//     //   children: [
//     //     { element: <Navigate to="/dashboard/app" />, index: true },
//     //     { path: 'app', element: <DashboardAppPage /> },
//     //     { path: 'onboard/distributor', element: <DistributorOnboard /> },
//     //     { path: 'onboard/retailor', element: <RetailorOnboard /> },
//     //     { path: 'module-management', element: <ModuleManagement /> },
//     //     { path: 'Empolyee-onboard', element: <EmployeeOnboard /> },
//     //     { path: 'products', element: <ProductsPage /> },
//     //     { path: 'blog', element: <BlogPage /> },
//     //     { path: '/dashboard/department-Role', element: <DepartmentRole/> },
//     //   ],
//     // },
//     // {
//     //   element: <SimpleLayout />,
//     //   children: [
//     //     { element: <Navigate to="/login" />, index: true },
//     //     { path: '404', element: <Page404 /> },
//     //     { path: '*', element: <Navigate to="/404" /> },
//     //   ],
//     // },
//     // {
//     //   path: '*',
//     //   element: <Navigate to="/404" replace />,
//     // },
//   ]);

//   return routes;
// }


// import React, { useState, useContext, useEffect } from "react";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Login from "../views/Login/index.js";
// import Dashboard from "../views/Dashboard/index.js";
// import UserManagement from "../views/UserManagement/index.js";
// import PrivateRoute from "../components/PrivateRoutes/index.js";
// import { AuthContext } from "../components/contextAPI/ContextAPI.js";


// const RouterComponent = () => {
// //   const [isLoggedIn, setIsLoggedIn] = useState(false);
// const { auth, setAuth} = useContext(AuthContext)

// useEffect(() => {
// console.log("authValue",auth)
// }, [auth])

//   return (
//     <Router>
//       <Routes>
//         <Route path="/login" element={<Login />} />
//         <Route
//           path="/"
//           element={
//             <PrivateRoute>
//               <Dashboard /> 
//             </PrivateRoute>
//           }
//         />
//         <Route
//           path="/usermanagement"
//           element={<PrivateRoute><UserManagement/></PrivateRoute>}
//         />
//       </Routes>
//     </Router>
//   );
// };

// export default RouterComponent;
